import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { getVisibiliyValue, getGroupListData, getUserListData, loadVisibilitySys, getDocIndex, getBskIndex } from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { AuthService } from '@auth/auth.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { catchError, forkJoin, from, lastValueFrom, map, of } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { IndexedDbService } from '@service/indexeddb.service';

@Component({
    selector: 'app-list-requests',
    templateUrl: './list-requests.component.html',
    styleUrls: ['./list-requests.component.scss'],
})
export class ListRequestsComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public requests = [];
    public groupList = [];
    public userList = [];
    public resultList = [];
    public editorList = [];
    public indexList = [];
    public systemList = [];
    public propertiesList = [];
    public propBskList = [];    
    public visibilityList: any[];
    public isAdmin = false;
    public allowRequest: boolean = false;

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    constructor(
        private api: ApiV6Service,
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        private auth: AuthService,
        private _router: Router,
        protected translate: TranslateService,
        private indexedDbService: IndexedDbService
    ) {
        super(translate);
        this.menu.display = true;
        this.visibilityList = [];
        this.isAdmin = this.auth.isAdmin();        
        this.visibilityList = loadVisibilitySys(this.translate);
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        // this.visibilityList = VisibilityListSys;
        this.listColumns = [
            { header: this.translate.instant('Name'), field: 'name' },
            { header: this.translate.instant('Visibility'), field: 'visibilityLabel' },
            { header: this.translate.instant('Desc'), field: 'description' },
        ];
        return from(this.menu.getMenu()).pipe(
            map(result => {
                this.allowRequest = this.menu.allowRequest && this.menu.allowSearchIdx;
                this.findAll();
                this.commonService.checkReset();        
             }),
            catchError((error: any) => {
                console.log(error);
                return of(null);
            })).subscribe();
    }

    setFilteredList(event) {}

    private async findAll() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.readRequestsData());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.requests = wRes.data.getRequestList.data.map((item) => {
            item.name = item.label;
            item._label = item.label;
            item.reference = item.label;
            item.visibilityLabel = getVisibiliyValue(item);
            item.description = item.description;
            return item;
        });
        this.editorList = [...this.getEditorListData(wRes.data.getEditorList.CustomEditorList.CustomEditor)];
        this.groupList = [...getGroupListData(wRes.data.getGroupList.GroupList)];
        this.userList = [...getUserListData(wRes.data.getUserList.UserList)];
        this.resultList = [...this.getResultListData(wRes.data.getResultList)];
        this.indexList = this.indexedDbService.variableStorage.Variable.filter((item) => {
            if (item.Name.substring(0, 4) !== 'sys_') {
                return item;
            }
        });
        this.systemList = this.indexedDbService.variableStorage.Variable.filter((item) => {
            if (item.Name.substring(0, 4) === 'sys_') {
                return item;
            }
        });
        this.propertiesList = getDocIndex(this.translate);
        this.propBskList = getBskIndex(this.translate);
    }

    private readRequestsData() {
        return forkJoin([
            this.api.getCustomEditorlist(),
            this.api.execUrlAction('getrequests',''),
            this.api.execUrlAction('getuserlist', ''),
            this.api.execUrlAction('getgrouplist', ''),
            this.api.execUrlAction('getresults','')]).pipe(
            map(([getEditorList, getRequestList, getUserList, getGroupList, getResultList]) => {
                return { getEditorList, getRequestList, getUserList, getGroupList, getResultList };
            })
        );
    }

    private getResultListData(aData) {
        let warray = [];
        warray.push({ label: this.translate.instant('Def_Dis'), value: null });
        aData.data.map((item) => {
            warray.push({ label: item.label, value: item.id });
        });
        return warray;
    }

    private getEditorListData(aData) {
        let warray = [];
        aData.map((item) => {
            warray.push({ label: item.Information.Name, value: item.Information.Name });
        });
        return warray;
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        if (event.duplicate === true) {
            this.addTab(event);
        } else {
            this.update(event);
        }
    }

    private update(event) {
        this.requests = this.requests.map((item) => {
            if (item.id === event.data.entete.id) {
                item.label = event.data.entete.name;
                item.name = event.data.entete.name;
                item.reference = event.data.entete.name;
                item.visibility = event.data.entete.visibility;
                item.visibilityLabel = getVisibiliyValue(item);
                item._label = event.data.entete.name;
                item.description = event.data.entete.desc;
                return item;
            } else {
                return item;
            }
        });
        this.requests = [...this.requests];
        this.closeTab(event);
    }

    addTab(event) {
        this.requests.push(event.data.entete);
        this.requests = [...this.requests];
        this.requests = this.requests.map((item) => {
            item.label = item.name;
            item._label = item.name;
            item.reference = item.name;
            item.visibilityLabel = getVisibiliyValue(item);
            return item;
        });
        if (event.duplicate === true) {
            this.closeTab(event);
        } else {
            this.closeTabsheet(this._event);
            this.index = this.index - 1;
        }
    }

    deleteTab(event) {
        this.requests = this.requests.filter((item) => {
            return item.id !== event.data.id;
        });
        this.requests = [...this.requests];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_Del', {label: event.data.name}),
            () => {
                this.delete(event);
            }
        );
    }

    public async delete(event) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deleterequest', event.data.id ));
            this.deleteTab(event);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }            
    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.reference);
        }
    }

    public goRequest() {
        this._router.navigate(['./page-request-list']);
    }

    sortReference(event: any): void {}

    private getDataRequest(aid) {
        return this.requests.filter((item) => {
            return item.id === aid;
        });
    }
}
